import { PROVIDER_DETAILS_COOKIE } from '../config';
import { regionMap } from '../data/regionMap';

/**
 * Get the current provider's region from localStorage.
 * This is a standalone utility to avoid circular dependencies with getHeaders.
 * @returns {string|undefined} Provider region (CAM, APAC, EMEA, CLASA) or undefined
 */
const getProviderRegion = () => {
  try {
    const cached = JSON.parse(
      localStorage.getItem(PROVIDER_DETAILS_COOKIE),
    );
    if (!cached?.value) return undefined;

    const { providerId, providerList } = cached.value;

    // Tier 1: Try to get region from current provider in cached list
    if (providerList?.providers) {
      const provider = providerList.providers.find(
        (p) => p.id === providerId,
      );
      if (provider?.region) return provider.region;

      // Tier 2: Fallback to static region map using provider's country code
      const countryCode = provider?.countryCode;
      const region = regionMap.find(
        (r) => r.countryCode === countryCode,
      );
      if (region?.region) {
        return region.region;
      }
    }

    return undefined;
  } catch {
    return undefined;
  }
};

export default getProviderRegion;
